import { InputText } from "primereact/inputtext";
import React, { useState, useContext } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
// import digio from "../Esign/digio"
import digilocker from "../digilocker"
import $ from "jquery";
import { mask } from "primereact/utils";
import { Context } from "../../Context/GlobalContext";
import { Chip } from "@mui/material";
import verified from "../../assets/check-mark.png"
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { ThreeDots } from "react-loader-spinner";


const PermanentAddress = ({ msg }) => {
  const { personal } = useContext(Context)
  const [address, setAddress] = useState("");
  const [error, setError] = useState("");
  const [digiRequest, setDigiRequest] = useState([]);
  const [loading, setLoading] = useState(false)
  const [showMessage, setShowMessage] = useState(false);
  const [isAuth, setAuth] = useState(sessionStorage.getItem("userCode"));
  
  function IntializeDigigo(
    options,
    request_id,
    customer_identifier,
    access_token,
    myValues
  ) 
  {
    var digilocker = new DigiLocker(options);
  digilocker.initdg(myValues);
  digilocker.submitdg(request_id,customer_identifier, access_token,myValues);
   
  }

  const userCode = sessionStorage.getItem("userCode");
  const getUserData = async () => {
    try {
      const response = await axios.post(`${URL}/Address/getDetails`, {
        userCode: userCode,
      }, { withCredentials: true });
      setAddress(response.data.data);
    } catch (error) {
      console.log("error in get data", error);
    }
  };

  useEffect(() => {
    getUserData();
    
  }, []);

  useEffect(() => {
    if (isAuth) {
      navigate("/permanent");
    } else {
      navigate("/");
    }
  }, []);


  const handleData = async (event) => {
    setLoading(true)
    try {
      const response = await axios.post(`${URL}/Address/reqestDigilocker`, {
        userCode: userCode,
      }, { withCredentials: true });
      setDigiRequest(response.data.data);
      if(response.data.result.flag ==1){
        window.nextTab = "/segment";
        IntializeDigigo(
          "production",
          response.data.data.request_id,
          response.data.data.customer_identifier,
          response.data.data.access_token,
          {
            userCode:  userCode,
            requestId: response.data.data.request_id,
          }
        )
      }
      setLoading(false)
    } catch (error) {
      console.log("error in digio api", error);
      setLoading(false)
    }
  };
  const navigate = useNavigate();
  const URL = process.env.REACT_APP_BASE_URL;

  const closePopUp = () => {
    setShowMessage(false);
    navigate("/segment");
  };
  const dialogFooter = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={closePopUp}
      />
    </div>
  );

  return (
    <>
      <Dialog
        visible={showMessage}
        onHide={() => setShowMessage(false)}
        position="top"
        footer={dialogFooter}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-check-circle"
            style={{ fontSize: "5rem", color: "var(--green-500)" }}
          ></i>
          <h5 className="c_pop">Details Saved Successfully!</h5>
        </div>
      </Dialog>
      <Card
        style={{
          margin: "0.5em 2em 2em 2em",
          padding: "1em",
          borderRadius: 20,
        }}
      >
        <div className="line">
          <h2>
            Address
          </h2>
          <div>
              {msg.addressDetailStatus == "VERIFIED" ?   <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<img src={verified} alt='verify' width='25px' />} label={msg.addressDetailStatus}  variant="outlined" sx={{background: '#0080004f'}} />
            </div> : msg.addressDetailStatus == "PENDING" ?    <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<HourglassTopIcon />} label={msg.addressDetailStatus}  variant="outlined" sx={{background: '#d3d3436b'}} />
              
              
            
            </div>  : msg.addressDetailStatus == "REJECTED" ?
            <div
            style={{
              fontSize: 12,
              color:'red',
              float: "right",
              marginTop: 20,
              display:'contents'
            }}
          >{msg.addressDetailRemarks}</div> : null}
          </div>
          <hr />
        </div>
        <div className="right_panel1">
          <div style={{ width: "100%" }}>
            <div class="field grid">
              <label for="line-1" style={{ width: 75 }}>
                Line 1: <sup>*</sup>
              </label>
              <div class="col">
                <InputText
                  value={address.userAddressL1}
                  name="userAddressL1"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
            <div class="field grid">
              <label for="line-3" style={{ width: 75 }}>
                Line 3:
              </label>
              <div class="col">
                <InputText
                  value={address.userAddressL3}
                  name="userAddressL3"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
            <div class="field grid">
              <label for="pincode" style={{ width: 75 }}>
                Pincode: <sup>*</sup>
              </label>
              <div class="col">
                <InputText
                  value={address.userPincode}
                  name="userPincode"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
            <div class="field grid">
              <label for="country" style={{ width: 75 }}>
                Country: <sup>*</sup>
              </label>
              <div class="col">
                <InputText
                  value="India"
                  name="country"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <div class="field grid">
              <label for="line-2" style={{ width: 75 }}>
                Line 2:
              </label>
              <div class="col">
                <InputText
                  value={address.userAddressL2}
                  name="userAddressL2"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
            <div class="field grid">
              <label for="firstname3" style={{ width: 75 }}>
                City: <sup>*</sup>
              </label>
              <div class="col">
                <InputText
                  value={address.userCity}
                  name="userCity"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
            <div class="field grid">
              <label for="lastname3" style={{ width: 75 }}>
                State: <sup>*</sup>
              </label>
              <div class="col">
                <InputText
                  value={address.userState}
                  name="userState"
                  className="p-inputtext-sm h-5"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <p style={{ color: "red", fontSize: 12 }}>{error ? error : null}</p>

          <Button
            onClick={handleData}
            label={loading ? <ThreeDots
              height="20"
              width="80"
              radius="9"
              color="#ffffff"
              ariaLabel="three-dots-loading"
              wrapperStyle={{ display: 'flex', justifyContent: 'center', position: 'relative' }}
              wrapperClassName=""
              visible={true}
            /> :"Update Details As Per Aadhar"}
            className="p-button-raised mr-3 p-button-sm smc_color mw-3 smc_color"
            disabled={loading || msg.addressDetailStatus == "VERIFIED" 
            || msg.addressDetailStatus == "PENDING"
          }
          />
       
        </div>
      </Card>
    </>
  );
};

export default PermanentAddress;
